import { PageRouteProps } from "../../types";

export const packageRoutes: PageRouteProps[] = [
  {
    pathName: "/packages",
    module: ["PackagePurchase"],
    component: "Packages",
    type: "public",
    rejectRoles: ["manager", "company", "branch", "representative"],
    mode: "static",
  },
  {
    pathName: "/package/list",
    module: ["Ecommerce"],
    component: "MyPackages",
    type: "postLogin",
    rejectRoles: ["manager", "company", "branch", "representative"],
    mode: "static",
  },
  {
    pathName: "/package/view",
    module: ["Ecommerce"],
    component: "MyPackageDetail",
    type: "postLogin",
    mode: "dynamic",
  },
];
